import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import {
  FlyoutApplicationEnum,
  REGEX_PATTERN,
  UserTypeEnum,
} from "src/app/shared/common/common.enum";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDividerModule } from "@angular/material/divider";
import { GlobalServiceService } from "src/app/shared/services/global-service.service";
import {
  AdminService,
  AppData,
  AppDataPayload,
} from "src/app/api/admin.service";
import { FlyoutService } from "src/app/shared/services/flyout.service";

@Component({
  selector: "app-add-edit-app",
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    FormsModule,
  ],
  templateUrl: "./add-edit-app.component.html",
  styleUrl: "./add-edit-app.component.css",
})
export class AddEditAppComponent implements OnInit {
  @Input() appData!: AppData[];
  @Input() applicationList!: AppData[];
  @Output() onCancelClick = new EventEmitter<string>();
  @Output() onDataRefresh = new EventEmitter<void>();
  userTypeEnum = UserTypeEnum;
  appForm!: FormGroup;
  isMobile = false;
  placementCheck: { status: boolean; appName: string } = {
    status: false,
    appName: "",
  };
  cpamAppIDCheck: { status: boolean; appName: string } = {
    status: false,
    appName: "",
  };
  constructor(
    private fb: FormBuilder,
    private gbService: GlobalServiceService,
    private adminService: AdminService,
    private flyoutService: FlyoutService
  ) {
    this.isMobile = this.gbService.isMobile;
  }

  private setAppName() {
    this.appForm.get("appName")?.valueChanges.subscribe((value: string) => {
      if (value?.length > 0) {
        this.flyoutService.setFlyoutHeader(value);
      }
    });
    this.appForm.get("placement")?.valueChanges.subscribe((value: number) => {
      this.checkPlacement(value);
    });
    this.appForm.get("cpamAppId")?.valueChanges.subscribe((value: number) => {
      this.checkCAPMAppId(value);
    });
  }
  ngOnInit(): void {
    // const placementList = this.applicationList.map((x) => {
    //   return x.placement;
    // });
    
    this.appForm = this.fb.group({
      placement: [
        "",
        [
          Validators.required,
          Validators.pattern(REGEX_PATTERN.onlyNumberValidator),
        ],
      ],
      cpamAppId: [
        "",
        [
          Validators.required,
          Validators.pattern(REGEX_PATTERN.onlyNumberValidator),
        ],
      ],
      //isActive: ["", Validators.required],
      appName: ["", Validators.required],

      apps: this.fb.array([]),
    });

    this.appData.sort((a: AppData, b: AppData) =>
      b.type.toLowerCase().localeCompare(a.type.toLowerCase())
    );

    this.appData.forEach((appEle) => {
      const appForm = this.fb.group({
        AppId: [appEle.appId ?? 0],
        // AppOktaGroupId: [appEle.AppOktaGroupId],
        // AppName: [appEle.AppName, Validators.required],
        Type: [appEle.type, Validators.required],
        OktaSsoUrl: [appEle.oktaSsoUrl, Validators.required],
         IsActive: [appEle.isActive, Validators.required],
        // Placement: [appEle.Placement, Validators.required],
        // CPAMAppId: [appEle.CPAMAppId, Validators.required],
      });

      const data =
        this.appData && this.appData.length > 0 ? this.appData[0] : null;
      if (data) {
        this.appForm.patchValue({
          placement: data.placement,
          cpamAppId: data.cpamAppId,
          //isActive: data.isActive,
          appName: data.appName,
        });
      }

      this.getApps.push(appForm);

      this.setAppName();
    });

    // Object.keys(this.appForm.controls).forEach(key => {
    //   const control = this.appForm.get(key);
    //   if (control && control.invalid) {
    //     console.log('Invalid Control:', key);
    //     console.log('Errors:', control.errors);
    //   }
    // });
    
  }

  get getApps(): FormArray {
    return this.appForm.get("apps") as FormArray;
  }

  onSubmit() {
    const payload: AppDataPayload = {
      ...this.appForm.getRawValue(),
      //isActive: this.appForm.get("isActive")?.value ? 1 : 0,
    };
    //set isactive as integter for each app in apps array
    payload.apps = payload.apps.map((app: any, index: number) => {
      const formApp = this.getApps.at(index);
      const { IsActive, ...rest } = app; // Remove any existing isActive field
      return {
      ...rest,
      isActive: formApp.get('IsActive')?.value ? 1 : 0,
      };
    });
    //console.log("🚀 ~ file: add-edit-app.component.ts:144 ~ AddEditAppComponent ~ onSubmit ~ payload:", payload );
    if (this.appData && this.appData.length > 0) {
      const appId = this.appData[0].appId;
      if (!appId) {
        payload.createdBy =
          this.gbService.userData()?.["user-id"].toString() ?? "1";
      } else {
        payload.modifiedBy =
          this.gbService.userData()?.["user-id"].toString() ?? "1";
      }
    }
    this.adminService.addEditApplication(payload).subscribe((res) => {
      this.onCancel();
      this.onDataRefresh.emit();
    });
  }
  onCancel() {
    this.onCancelClick.emit(FlyoutApplicationEnum.applicationList);
  }
  checkPlacement(placement: number) {
    const appName =
      this.appData && this.appData.length > 0 ? this.appData[0].appName : "";
    const app = this.applicationList.find((item: AppData) => {
      return item.placement == placement && item.appName != appName;
    });
    this.placementCheck = app
      ? { status: true, appName: app.appName }
      : { status: false, appName: "" };
  }
  checkCAPMAppId(cpamAppId: number) {
    const appName =
      this.appData && this.appData.length > 0 ? this.appData[0].appName : "";
    const app = this.applicationList.find((item: AppData) => {
      return item.cpamAppId == cpamAppId && item.appName != appName;
    });
    this.cpamAppIDCheck = app
      ? { status: true, appName: app.appName }
      : { status: false, appName: "" };
  }
}
